import type { ReactNode } from "react";

/**
 * The reading column.
 *
 * `<main>` deliberately imposes no width or padding of its own, so a page can
 * go full-bleed when it wants to — the hero canvas has to reach the viewport
 * edges, and doing that from inside a padded container means `100vw` tricks
 * that break the moment a scrollbar appears. Pages opt into the column
 * instead of fighting their way out of it.
 */
export function Shell({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`mx-auto w-full max-w-[1120px] px-6 ${className}`}>
      {children}
    </div>
  );
}
